module.exports = __webpack_public_path__ + "static/media/camper_blue.a4036024.svg";